/* global site: false, __: false, app: true, win: true, urlParams: false, debounce, pad */

/**
 * [doSelect description]
 * @param  {[type]} newDate [description]
 * @param  {[type]} element [description]
 * @return {[type]}         [description]
 */
function doSelect(newDate, context){
	var input = $(context.element).prevAll('.date-input');

	input.val(function(){
		return newDate.getFullYear() + '/' + pad(newDate.getMonth() + 1, 2) + '/' + pad(newDate.getDate(), 2);
	});

	if(input[0].hasAttribute('data-paired-with')){
		var calObject = $('#' + input.data('paired-with'))[0].date,
			checkoutDate = new Date(newDate),
			duration = parseInt(input.closest('form').find('.stay-duation').val() || 5, 10);

		checkoutDate.setDate(checkoutDate.getDate() + duration);
		calObject.valid_date = function(date){
			return date.getTime() > newDate.getTime();
		};

		calObject.selected_date = checkoutDate;
		calObject.nav_date = checkoutDate;

		calObject.input.val(function(){
			return checkoutDate.getFullYear() + '/' + pad(checkoutDate.getMonth() + 1, 2) + '/' + pad(checkoutDate.getDate(), 2);
		});

		calObject.redraw();
	}

	input.addClass('hasValue');
	input.nextAll('.clear-input').click(function(e){
		input.val('');
		input.removeClass('hasValue');
		input.removeClass('show');
	});
	input.removeClass('show');

	if(input.hasClass('flight-date-start')){
		var hotelStartDate = input.closest('form').find('.hotel-date-start');

		hotelStartDate.val(input.val());
		doSelect(newDate, hotelStartDate[0].date);
	}

	if(input.hasClass('flight-date-end')){
		var hotelEndDate = input.closest('form').find('.hotel-date-end');

		hotelEndDate.val(input.val());
		doSelect(newDate, hotelEndDate[0].date);
	}

	if(input.closest('form').find('.stay-duation').length){
		input.closest('form').find('.stay-duation').val(function(){
			var checkInDate = new Date(input.closest('form').find('.check-in-date').val()),
				checkOutDate = new Date(input.closest('form').find('.check-out-date').val());

			return (checkOutDate - checkInDate) / (1000 * 3600 * 24);
		});
	}
};

$(document).ready(function(){
	/**
	 * flocp the booking widget tabs
	 * @param  {jQuery} scope teh actioned element
	 */
	function changeBookingWidgetTab(scope){
		var that = $(scope),
			widget = that.closest('.booking-widget'),
			form = widget.find('form');

		form.removeClass('show');
		widget.find('.booking-widget-tabs').children('div').removeClass('active');

		$(that.data('target')).addClass('show');
		that.addClass('active');
	}

	$('.booking-widget-form input.date-input').each(function(){
		var that = $(this);

		that[0].date = app.calendar({
			element: app.createCal(),
			input: this,
			nav_date: new Date(that.val()) || null,
			selected_date: new Date(that.val()) || null,
			on_select: doSelect,
			is_valid: function(date){
				var d = new Date();

				// d.setDate(d.getDate() + 6);
				d.setHours(0, 0, 0, 0);

				return date.getTime() >= d.getTime();
			}
		});

		that.parent().append(that[0].date.element).click(function(e){
			if(e.target === that[0]){
				$('.calendar').removeClass('show');
				that.siblings(that[0].date.element).addClass('show');
				win.on('click', that[0].date.close);
			}
		});
	});

	$('.booking-widget-tabs > div').click(function(e){
		e.preventDefault();
		changeBookingWidgetTab(this);
	});

	$('.booking-widget-tabs > div').on('focus').on('keypress', function(e){
		if(e.which === 32){
			e.preventDefault();
			changeBookingWidgetTab(this);
		}
	});

	$('.stay-duation').on('change', function(){
		var that = $(this),
			calObject = that.closest('form').find('.check-out-date')[0].date,
			checkoutDate = new Date(that.closest('form').find('.check-in-date')[0].date.selected_date),
			duration = parseInt(that.val() || 1, 10);

		checkoutDate.setDate(checkoutDate.getDate() + duration);
		calObject.selected_date = checkoutDate;
		calObject.nav_date = checkoutDate;

		calObject.input.val(function(){
			return checkoutDate.getFullYear() + '/' + pad(checkoutDate.getMonth() + 1, 2) + '/' + pad(checkoutDate.getDate(), 2);
		});

		calObject.redraw();
	});

	$().on('change', function(){

	});

	$('.ChildrenNumber').on('change', function(e){
		var that = $(this),
			ni;

		that.closest('form').find('.child-ages').html('');
		for(ni = 0; ni < parseInt(that.val(), 10); ++ni){
			that.closest('form').find('.child-ages').append('<div class="input-wrap"><label for="child-age-' + ni + '">' + __('Child %s Age', ni + 1, 'halepuna_domain') + '</label><input id="child-age-' + ni + '" type="number" name="Children" required></div>');
		}
	});

	$('.airport-typeahead').each(function(){
		if($(this).val()){
			var code = $(this).val().match(/\(([A-Za-z].*)\)/i);
			$(this).siblings('[name="GoDepPoint"]').val(code[1]);
		}
	});

	$('.airport-typeahead').on('keyup', debounce(function(e){
		var that = $(this),
			data = {
				action: 'airport_search',
				searchString: that.val()
			};

		that.nextAll('.typeahead-results').html('');
		if(that.val().length){
			$.ajax({
				type: 'POST',
				url: app.ajaxUrl,
				data: data,
				success: function(data){
					if(parseInt(data, 10) !== 0){
						var key;

						that.nextAll('.typeahead-results').addClass('show');
						if(!$.isEmptyObject(data.data)){
							for(key in data.data){
								that.nextAll('.typeahead-results').append('<div class="typeahead-item" data-val="' + data.data[key].AirportCode + '">(' + data.data[key].AirportCode + ') ' + data.data[key].OnlyAirportName + ', ' + data.data[key].OnlyCoutryName + '</div>');
							}
						}else{
							that.nextAll('.typeahead-results').append('<div class="no-results">' + __('No Results Found.', 'halepuna_domain') + '</div>');
						}

						$('.typeahead-item').click(function(){
							var item = $(this);

							that.val(item.text());
							that.nextAll('[type="hidden"]').val(item.data('val'));
						});

						win.on('click', function(evt){
							if($(evt.target).closest('.typeahead-container').length < 1 && !$(evt.target).is('.typeahead-container')){
								$('.typeahead-results').removeClass('show');
								win.off('click');
							}
						});
					}else{
						app.notification(__('Internal error. Please try again.', 'halepuna_domain'), 'error');
					}
				}
			});
		}else{
			that.nextAll('.typeahead-results').html('<div class="no-results">' + __('Start typing to search.', 'halepuna_domain') + '</div>');
		}
	}, 300));

	$('.booking-widget-form').submit(function(e){
		var self = $(this),
			errors = [],
			values = urlParams(self.serialize());

		e.preventDefault();

		self.find('input, select').each(function(){
			var that = $(this);

			that.removeClass('error');

			if(that.hasClass('date-input')){
				var comparator = new Date(),
					thatDate = new Date(that.val());

				comparator.setDate(comparator.getDate());
				comparator.setHours(0, 0, 0, 0);

				if(thatDate.getTime() < comparator.getTime()){
					errors.push({input: that, message: __('Date must be at least 5 days from today', 'halepuna_domain')});
					that.addClass('error');
					that.nextAll('span.error').text(__('Must be > 5 days from today', 'halepuna_domain'));
				}
			}

			if(that.attr('required') && !that.val()){
				errors.push({input: that, message: __('You are missing a required field', 'halepuna_domain')});
				that.addClass('error');
				that.nextAll('span.error').text(__('You are missing a required field', 'halepuna_domain'));
			}
		}).promise().done(function(){
			var ni;

			if(values.ChildrenNumber && self.hasClass('rooms-air-form')){
				if(parseInt(values.Adult, 10) + parseInt(values.ChildrenNumber, 10) > 3){
					errors.push({input: null, message: __('Maximum travelers must be 3 or less', 'halepuna_domain')});
					self.find('[name="Adult"], [name="ChildrenNumber"]').addClass('error');
					self.find('[name="Adult"]').nextAll('span.error').text(__('Max. 3 passengers', 'halepuna_domain'));
				}
			}

			if(errors.length && errors.length > 0){
				var focused = false;
				for(ni = 0; ni < errors.length; ++ni){
					if(!focused){
						if(errors[ni].input){
							errors[ni].input.focus();
							focused = true;
						}
					}
					//					app.notification(errors[ni].message, 'error');
				}

				return false;
			}else{
				self.find('.typeahead-results').html('<div class="no-results">' + __('Start typing to search.', 'halepuna_domain') + '</div>');
				self.unbind();
				self.submit();
			}
		});
	});
});
